module.exports = __webpack_public_path__ + "img/capa-padrao-educacao.1754ee85.png";